import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { LocalStorageService } from 'ngx-localstorage';
import { concatMap, map, mergeMap, retryWhen, take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SharedService } from '../shared/shared.service';
import { FormService } from '../shared/form.service';
import { AuthService } from './auth.service';
// Allianz AEM
import {
  EmbeddedDataModule,
  EmbeddedDataService,
  NORMALIZE_URL_SERVICE_CONFIG_TOKEN,
  NormalizeUrlModule,
  NormalizeUrlService
} from '@allianz/ngx-aem-integration'

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  postCodes;
  private readonly URL_TO_ERROR_DESCRIPTION = {
    '/api/v1/enums/postcodes-cities/': 'Грешка при извличане на номeнклатура за пощенски кодове',
    '/api/v1/enums/cities-postcodes/': 'Грешка при извличане на номeнклатура за пощенски кодове',
    '/api/v1/enums/postcodes/': 'Грешка при извличане на номенклатура за пощенски кодове',
    '/api/v1/enums/company-types/': 'Грешка при извличане на номенклатура за видове компании',
    '/api/v1/enums/claims-number/': 'Грешка при извличане на номeнклатура за брой претенции',
    '/api/v1/enums/years/': 'Грешка при зареждане на номенклатура за години',
    '/api/v1/enums/currency/': 'Грешка при зареждане на номенклатура за валута',
    '/api/v1/table/base/': 'Грешка при зареждане на таблицата с рискове',
    '/api/v1/person/': 'Грешка при зареждане на физическо лице по ЕГН',
    '/api/v1/enums/bnf-bank/': 'Грешка при зареждане на номeнклатура за банка',
    '/api/v1/vehicle-owner/': 'Грешка при зареждане на данни за собственик на МПС',
    '/api/v1/product-proposals/': 'Грешка при зареждане на данни за предложения и пакети',
    '/api/v1/calculatedPremiums/': 'Грешка при изчисляване на премиум за пакетите',
    '/api/v1/table/': 'Грешка при зареждане на таблицата с покрития',
    '/api/v1/enums/additional-info-by-vehicle-build-year/2017': 'Грешка при зареждане на номенклатура за самоучастие, компенсационен метод и др.',
    '/api/v1/policy/get-damages/': 'Грешка при зареждане на данни за щети на МПС',
    '/api/v1/policy/': 'Грешка при издаване на полица',
    
  };
  private readonly URL_TO_SCREEN = {
    '/package-selection': 'Изберете най-подходящия за Вас пакет',
    '/newCarDetails-4': 'Финални детайли',
    '/newRegistered-car2': 'Финални данни за собственика',
    '/newRegistered-car3': 'Лични данни',
    '/information': 'Информация - Ще ви изпратим SMS',
    '/payment': 'Плащане',
    '/object-details': 'МПС и собственик - данни за автомобила 1 екран (Каква е Марката на автомобила?), регистрирано МПС',
    '/object-details-2': 'МПС и собственик - данни за автомобила 2 екран (Какъв е пробегът на автомобила Ви?), регистрирано МПС',
    '/object-additional-details': 'Финални детайли - Автомобилът закупен ли е с банков кредит?',
    '/insurerData': 'Финални данни за вас - Лични данни',
    '/consents': 'Съгласия и Декларации',
    '/contact-details': 'Вашата полица - Финални данни за собственика',
  };
  newRequest: HttpRequest<any>;
  constructor(public localStorage: LocalStorageService,
    public router: Router,
    private formService: FormService,
    public authService: AuthService,
    private http: HttpClient,
    public sharedService: SharedService,
    public normalizeUrlService: NormalizeUrlService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.localStorage.get('x-token');
    const language = this.localStorage.get('language');
    if (!request.url.startsWith('/api')) {
      return next.handle(request);
    } else {
      const newRequest = new HttpRequest(request.method, this.normalizeUrlService.normalizeUrl(request.url), request.body, request);
      return this.authService.token$.pipe(
        //map(token => request.clone({setHeaders: {Authorization: `Bearer ${token}`, 'X-Language': language}})),
        map(token => {
          if(request.url.includes('/enums/cities/')) {
            return newRequest.clone({ setHeaders: { Authorization: `Bearer ${ token }`, 'X-Language': 'BG' } })
          }else {
            return newRequest.clone({ setHeaders: { Authorization: `Bearer ${ token }`, 'X-Language': language } })
          }

        }),
        concatMap(authReq => next.handle(authReq)),
        retryWhen((errors: Observable<any>) => {
          return errors.pipe(
            mergeMap((error, index) => {
              if (error.status !== 401) {
                var retrySource = new Subject();
                if (error instanceof HttpErrorResponse) {
                  this.sharedService.loadingStep = false;
                  this.sharedService.loadingSpinner = false;
                  if (this.router.url === '/somethingWentWrong') {
                    return;
                  }

                  let errorDescription = error?.error?.opusErrors?.map(x => x.errorMessage)?.join(' ') || `${ error.message } ${ JSON.stringify(error.error) }`;
                  if (!error?.error?.opusErrors) {
                    const errorKey = Object.getOwnPropertyNames(this.URL_TO_ERROR_DESCRIPTION).find(url => error.url.includes(url));
                    if (errorKey) {
                      errorDescription = this.URL_TO_ERROR_DESCRIPTION[errorKey] || errorDescription;
                    }
                  }

                  let screen = this.router.url;
                  const screenErrorKey = Object.getOwnPropertyNames(this.URL_TO_SCREEN).find(url => screen === url);
                  if (screenErrorKey) {
                    screen = this.URL_TO_SCREEN[screenErrorKey] || screen;
                  }

                  const formData = this.formService.currentForm.getRawValue();
                  const payload: any = {
                    screen: screen,
                    errDescription: errorDescription,
                    city: formData.cityName,
                    postcode: formData?.personOwnerData?.postCode || formData?.companyOwnerData?.postCode
                  };
                  if (this.sharedService.calculatePremiums$) {
                    this.sharedService.calculatePremiums$.subscribe(res => {
                      payload.data = res;
                      this.sharedService.updateErrorPayload(payload);
                    })
                  } else {
                    this.sharedService.updateErrorPayload(payload);
                  }
                }
                if (newRequest.url.indexOf('calculatedPremiums') > -1) {
                  this.router.navigate(['/somethingWentWrong']);
                }
                error.complete && error.complete();
                return throwError(error);
              }
              // any other error than 401 with {error: 'invalid_grant'} should be ignored by this retryWhen
              if (index === 0) {
                // first time execute refresh token logic...
                return this.authService.refreshToken$;
              }
              return throwError(error);
            }),
            take(2)
          );
        }));
    }
  }
}
